import React, { useEffect, useState } from "react";
import { Drawer, Box, Typography, Stack, Divider, Avatar } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { GoPencil } from "react-icons/go";
import { BsThreeDotsVertical } from "react-icons/bs";
import { CiClock2 } from "react-icons/ci";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { FaFilePdf } from "react-icons/fa";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { getTaskSeparateById } from "../../services/taskManagement.service";
import Status_Icon from "../../assets/images/status_Icon.svg";
import DueDateIcon from "../../assets/images/dueDateIcon.svg";
import AssignedBy_Icon from "../../assets/images/AssignedBy.svg";
import Assigness_Icon from "../../assets/images/Assignees_Icon.svg";
import { IoFlagOutline } from "react-icons/io5";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const TaskDrawer = ({ open, onClose, taskId }) => {
  const [value, setValue] = useState("one");
  const [selectedTask, setSelectedTask] = useState(null);

  const GetTaskById = async () => {
    try {
      const res = await getTaskSeparateById(taskId);
      setSelectedTask(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetTaskById();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // If task is null, return null (don't render the drawer)
  if (!taskId) {
    return null;
  }

  const steps = [
    {
      id: 1,
      avatar: "https://via.placeholder.com/50",
      title:
        "Vidhya changed the status of “Company profile corrections and redesigning the layouts” from To - Do to In Progress",
      subtitle: "March 10, 2025. 10:50 AM.",
    },
    {
      id: 2,
      avatar: "https://via.placeholder.com/50",
      title:
        "Vidhya changed the status of “Company profile corrections and redesigning the layouts” from To - Do to In Progress",
      subtitle: "March 10, 2025. 10:50 AM.",
    },
    {
      id: 3,
      avatar: "https://via.placeholder.com/50",
      title:
        "Vidhya changed the status of “Company profile corrections and redesigning the layouts” from To - Do to In Progress",
      subtitle: "March 10, 2025. 10:50 AM.",
    },
    {
      id: 4,
      avatar: "https://via.placeholder.com/50",
      title:
        "Vidhya changed the status of “Company profile corrections and redesigning the layouts” from To - Do to In Progress",
      subtitle: "March 10, 2025. 10:50 AM.",
    },
    {
      id: 5,
      avatar: "https://via.placeholder.com/50",
      title:
        "Vidhya changed the status of “Company profile corrections and redesigning the layouts” from To - Do to In Progress",
      subtitle: "March 10, 2025. 10:50 AM.",
    },
  ];

  console.log("selectedTask", selectedTask);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ borderRadius: "12px", height: "100vh" }}
    >
      <Stack width={"400px"} height="100vh">
        {/* Fixed Header Section */}
        <Stack
          sx={{
            justifyContent: "space-between",
            flexDirection: "row",
            padding: "20px",
          }}
        >
          <Stack>
            <IoMdClose onClick={onClose} style={{ cursor: "pointer" }} />
          </Stack>
          <Stack flexDirection={"row"} gap={"10px"}>
            <GoPencil />
            <BsThreeDotsVertical />
          </Stack>
        </Stack>
        <Divider />

        <Box sx={{ padding: "20px 30px" }}>
          <Typography
            variant="h6"
            sx={{ marginBottom: 2, fontSize: "20px", fontWeight: "600" }}
          >
            {selectedTask?.title}
          </Typography>

          {/* Static Content */}
          <Stack marginBottom={1.5}>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <CiClock2 />
                  <Typography color="#687280" fontSize={"12px"}>
                    Created Time
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {dayjs(selectedTask?.createdAt).format("MMMM D, YYYY")}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    {dayjs(selectedTask?.createdAt).utc().format("h:mm A")}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <img
                    src={Status_Icon}
                    alt=""
                    height={"14px"}
                    width={"14px"}
                  />
                  <Typography color="#687280" fontSize={"12px"}>
                    Status
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {selectedTask?.status}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    {""}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <IoFlagOutline />
                  <Typography color="#687280" fontSize={"12px"}>
                    Priority
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {selectedTask?.priority}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    { }
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <img
                    src={DueDateIcon}
                    alt=""
                    width={"14px"}
                    height={"14px"}
                  />
                  <Typography color="#687280" fontSize={"12px"}>
                    Due Date
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {dayjs(selectedTask?.deadLineDate).format("MMMM D, YYYY")}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    {dayjs(selectedTask?.deadLineDate).utc().format("h:mm A")}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <img
                    src={Assigness_Icon}
                    alt=""
                    width={"12px"}
                    height={"12px"}
                  />
                  <Typography color="#687280" fontSize={"12px"}>
                    Assignees
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {selectedTask?.assignedToName}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    {""}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack marginBottom={"10px"}>
              <Stack flexDirection={"row"} gap={2}>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <img
                    src={AssignedBy_Icon}
                    alt=""
                    height={"14px"}
                    width={"14px"}
                  />
                  <Typography color="#687280" fontSize={"12px"}>
                    AssignedBy
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"} alignItems={"center"} gap={"10px"}>
                  <Typography
                    fontSize={"12px"}
                    sx={{ color: "black", fontWeight: "600" }}
                  >
                    {selectedTask?.assignedByName}
                  </Typography>
                  <Typography fontSize={"12px"} color="#98A0AC">
                    {""}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          {/* Description Box */}
          <Stack
            sx={{
              backgroundColor: "#F1F6FA",
              padding: "10px",
              borderRadius: "8px",
            }}
          >
            <Typography
              sx={{ fontSize: "12px", color: "black", fontWeight: "500" }}
            >
              Description
            </Typography>
            <Typography sx={{ fontSize: "12px", color: "#687280" }}>
              {selectedTask?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
            </Typography>
          </Stack>

          {/* Tabs */}
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="inherit"
              indicatorColor="primary"
              sx={{
                "& .MuiTabs-indicator": { backgroundColor: "#008080" },
                "& .MuiTab-root": {
                  color: "black",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textTransform: "none",
                },
                "& .Mui-selected": { color: "#008080", fontWeight: "bold" },
              }}
              aria-label="secondary tabs example"
            >
              <Tab value="one" label="Activity" />
              <Tab value="two" label="Attachments" />
              <Tab value="three" label="Comments" />
            </Tabs>
          </Box>
        </Box>

        {/* Scrollable Tab Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto", // Scroll only here
            padding: "10px 30px",
          }}
        >
          {value === "one" && (
            <Box display="flex" flexDirection="column" gap={1.5}>
              {selectedTask?.history?.map((step, index) => (
                <Box key={step.id} display="flex" alignItems="flex-start">
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <Avatar
                      sx={{
                        width: 28,
                        height: 28,
                        fontSize: "12px",
                        backgroundColor: "#008080",
                      }}
                    >
                      {step.assignedTo.charAt(0)}
                    </Avatar>

                    {index !== steps.length - 1 && (
                      <Box
                        sx={{
                          width: "2px",
                          height: 40,
                          borderLeft: "2px dotted #008080",
                          marginTop: 1,
                        }}
                      />
                    )}
                  </Box>
                  <Box ml={2}>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: "12px", fontWeight: "500" }}
                    >
                      {step?.assignedTo}
                    </Typography>
                    {console.log(step.isChanges, "isChanged")}
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "10px",
                        fontWeight: "500",
                        color: "#687280",
                      }}
                    >
                      {step?.isChanges}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "10px",
                        fontWeight: "500",
                        color: "#687280",
                      }}
                    >
                      {dayjs(step?.date).format("MMMM D, YYYY")}{" "}
                      {dayjs(step?.date).utc().format("h:mm A")}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          )}

          {value === "two" && (
            <Box display="flex" flexDirection="column" gap={1.5}>
              {console.log(selectedTask?.file)}
              {selectedTask?.file?.map((attachment) => (
                <Box
                  key={attachment?._id}
                  alignItems="center"
                  gap={1}
                  marginLeft={"10px"}
                >
                  <Stack direction={"row"} alignItems={"center"} spacing={1}>
                    <Stack flexDirection={"row"} alignItems={"center"}>
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          fontSize: "12px",
                          backgroundColor: "#008080",
                        }}
                      >
                        S
                      </Avatar>
                    </Stack>
                    <Stack marginLeft={"38px"} gap={1}>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        Vidhya
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "10px",
                          fontWeight: "500",
                          color: "#687280",
                          marginTop: "-5px",
                        }}
                      >
                        March 10, 2025. 10:50 AM
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={1}
                    sx={{
                      border: "1px solid #E5E9F1",
                      borderRadius: "4px",
                      padding: "5px",
                      maxWidth: "208px",
                      marginLeft: "40px",
                      marginTop: "7px",
                    }}
                  >
                    <Stack>
                      <FaFilePdf color="red" size={18} />
                    </Stack>
                    <Stack>
                      <Typography sx={{ fontSize: "12px", color: "#324054" }}>
                        {attachment?.fileName}
                      </Typography>
                      <Stack flexDirection={"row"}>
                        <Typography sx={{ fontSize: "8px", color: "#687280" }}>
                          PDF
                        </Typography>
                        <Typography sx={{ fontSize: "8px", color: "#687280" }}>
                          2.53mb
                        </Typography>
                      </Stack>
                    </Stack>
                    <Stack marginLeft={"50px"}>
                      <IoCloudDownloadOutline />
                    </Stack>
                  </Stack>
                </Box>
              ))}
            </Box>
          )}

          {value === "three" && (
            <Box display="flex" flexDirection="column" gap={1.5}>
              {selectedTask.comments.map((comment) => (
                <Box
                  key={comment.id}
                  display="flex"
                  alignItems="flex-start"
                  gap={2}
                >
                  <Avatar
                    sx={{
                      width: 28,
                      height: 28,
                      fontSize: "12px",
                      backgroundColor: "#008080",
                    }}
                  >
                    {comment?.assignedTo?.charAt(0)}
                  </Avatar>{" "}
                  <Box>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#000000",
                      }}
                    >
                      {comment?.assignedTo}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "10px",
                        fontWeight: "500",
                        color: "#687280",
                      }}
                    >
                      {dayjs(comment?.date).format("MMMM D, YYYY")}{" "}
                      {dayjs(comment?.date).utc().format("h:mm A")}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: "12px", fontWeight: "500" }}
                    >
                      {comment?.commentText?.replace(/<\/?[^>]+(>|$)/g, "") ||
                        ""}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Stack>
    </Drawer>
  );
};

export default TaskDrawer;
